import React from 'react'
import PropTypes from 'prop-types'
import NumberField from '../../../../components/forms/NumberField'
import Input from '../../../../components/forms/Input'
import { formatThousands } from '../../../utils/RPQSUtils'

// Hors saisie, la valeur est affichée avec séparateur de milliers (impossible dans un champ numérique).
const PopulationField = ({
    title = '',
    value,
    onChange = () => {},
    disabled = false,
}) => disabled ? (
    <Input
        title={title}
        value={formatThousands(value)}
        disabled
    />
) : (
    <NumberField
        title={title}
        value={value}
        onChange={onChange}
        active
    />
)

PopulationField.propTypes = {
    title: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
}

export default PopulationField
